/** @jsxImportSource @emotion/react */

import { forwardRef } from 'react'
import css from '@emotion/css/macro'
import PropTypes from 'prop-types'
import { Column } from '../Layout'
import GamePageHeaderMatchup from '../../pages/Game/GamePageHeaderMatchup'

/**
 * GameHeaderSection component
 * Renders the header section with breadcrumbs, matchup, and date/time information for a game page.
 * This is a shared component extracted from GamePageHeader for reusability.
 *
 * @param {Object} props
 * @param {Object} props.organization - Organization object
 * @param {Object} props.game - Game object containing game details
 * @param {string} props.title - Page title for the game
 * @param {Object} [props.fullGameType] - Full game type object
 * @param {boolean} props.isDesktop - Whether the view is desktop
 * @param {boolean} [props.isSoccer=false] - Whether the game is soccer
 * @param {Object} [props.error] - Error object for conditional rendering
 * @param {React.Ref} ref - Forwarded ref to the container div
 */
const GameHeaderSection = forwardRef(
  ({ game, isDesktop, isSoccer = false, error = null }, ref) => {
    return (
      <div
        ref={ref}
        css={css`
          width: 100%;
          padding-top: 8px;
          ${!isDesktop &&
          css`
            position: fixed;
            padding: 0 8px 16px;
            margin-left: 0;
            margin-right: 0;
          `};
        `}
      >
        {!error && (
          <Column column fullWidth>
            <GamePageHeaderMatchup
              isDesktop={isDesktop}
              game={game}
              isSoccer={isSoccer}
            />
          </Column>
        )}
      </div>
    )
  }
)

GameHeaderSection.displayName = 'GameHeaderSection'

GameHeaderSection.propTypes = {
  game: PropTypes.any.isRequired,
  isDesktop: PropTypes.bool.isRequired,
  isSoccer: PropTypes.bool,
  error: PropTypes.any,
}

export default GameHeaderSection
